import React, { useState } from 'react';
import { sixYardAxios } from '../../../../sixYardAxios';
import classes from './newsLetter.module.css';
import InputField from '../../inputField/inputField';
import PromptMessage from '../../promptMessage/promptMessage';

const NewsLetter = (props) => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState(false);
    const [showPrompt, setShowPrompt] = useState(false);
    const isEnglish = parseInt(localStorage.getItem('language')) === 1;

    const translations = {
        subscribe: {
            en: 'Subscribe',
            ar: 'اشتراك'
        },
        placeholder: {
            en: 'Enter your email',
            ar: 'أدخل بريدك الإلكتروني'
        }
    };

    const NewsLetterSubmitHandler = (event) => {
        event.preventDefault();
        sixYardAxios.post("/newsletter/subscribe", { email: email }).then(res => {
            setMessage(res.data.message)
            setEmail("");
        }).catch(error => {
            setMessage(error.response.data.message);
        });
        setShowPrompt(true);
    }

    const getPlaceholder = () => {
        if (props.newsLetterSections?.meta_data?.input_placeholder) {
            return props.newsLetterSections.meta_data.input_placeholder;
        }
        return isEnglish ? translations.placeholder.en : translations.placeholder.ar;
    };

    return (
        <div className={classes.NewsLetter} dir={isEnglish ? 'ltr' : 'rtl'}>
            <h4>{props.newsLetterSections?.title}</h4>
            <p>{props.newsLetterSections?.content}</p>
            <form className={classes.NewsLetterForm} onSubmit={(event) => NewsLetterSubmitHandler(event)}>
                <InputField 
                    elementType='input'
                    elementConfig={{
                        type: "email",
                        placeholder: getPlaceholder(),
                        required: `${email ? 0 : 1}`,
                        dir: "ltr"
                    }}
                    value={email}
                    changed={event => setEmail(event.target.value)}
                />
                <button type="submit" aria-label="email">
                    {isEnglish ? translations.subscribe.en : translations.subscribe.ar}
                </button>
            </form>
            {message && showPrompt && (
                <PromptMessage 
                    successMessage 
                    message={message} 
                    status='CONGRATULATIONS' 
                    button='CLOSE' 
                    click={() => setShowPrompt(false)} 
                />
            )}
        </div>
    )
}

export default NewsLetter;